// extracted by mini-css-extract-plugin
export default {"footer":"Legal_footer__+9JHu","logo":"Legal_logo__JeTUY","content":"Legal_content__qH3E-","footerLinks":"Legal_footerLinks__0XJXM","footerBanner":"Legal_footerBanner__B9FzR"};